<template>
  <section id="about" class="home3-about">
    <v-container>
      <v-row align="center">
        <v-col cols="12" md="6" class="order-2 order-md-1">
          <div class="home3-section-header home3-section-header--left mb-6 mb-md-0">
            <span class="home3-section-header__tag">About</span>
            <h2 class="home3-section-header__title">Built for modern school transportation</h2>
            <p class="home3-section-header__desc">
              {{ systemName }} connects schools, drivers, and parents through a single
              platform designed to make every school trip safer, more transparent, and easier to manage.
            </p>
          </div>

          <div
            v-for="(point, i) in points"
            :key="i"
            class="home3-about__point d-flex align-start mb-5"
          >
            <div class="home3-about__point-icon mr-4">
              <v-icon color="primary">{{ point.icon }}</v-icon>
            </div>
            <div>
              <h4 class="home3-about__point-title">{{ point.title }}</h4>
              <p class="home3-about__point-text">{{ point.text }}</p>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6" class="order-1 order-md-2 d-flex justify-center">
          <div class="home3-about__visual">
            <v-img
              src="@/assets/images/landing/about-bus-tracker.png"
              max-width="560"
              class="home3-about__hero-img"
              contain
            />
            <div class="home3-about__badge">
              <v-icon color="white" small class="mr-1">mdi-check-circle</v-icon>
              Trusted by schools worldwide
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  props: {
    systemName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      points: [
        {
          icon: 'mdi-bus-school',
          title: 'Complete fleet visibility',
          text: 'View all buses, drivers, and active trips from a centralized dashboard with real-time status updates.',
        },
        {
          icon: 'mdi-account-group',
          title: 'Role-based access',
          text: 'Separate portals for administrators, school staff, drivers, and parents — each with the right level of access.',
        },
        {
          icon: 'mdi-account-check-outline',
          title: 'Driver assignment control',
          text: 'Assign and unassign drivers to buses and trips quickly with clear operational visibility.',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import './home3-theme.scss';

.home3-about {
  @include home3-section-padding;
  background: #fff;
}

.home3-section-header--left {
  text-align: left;
  margin-left: 0;
  margin-right: 0;
  max-width: 100%;
}

.home3-section-header {
  &__tag {
    display: inline-block;
    padding: 4px 14px;
    margin-bottom: 1rem;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: $home3-primary;
    background: rgba($home3-primary, 0.1);
    border-radius: 100px;
  }

  &__title {
    font-size: clamp(1.75rem, 3vw, 2.25rem);
    font-weight: 700;
    color: $home3-text;
    letter-spacing: -0.02em;
    line-height: 1.2;
    margin-bottom: 1rem;
  }

  &__desc {
    font-size: 1.05rem;
    line-height: 1.7;
    color: $home3-text-muted;
    margin: 0;
  }
}

.home3-about {
  &__point-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    min-width: 44px;
    background: rgba($home3-primary, 0.1);
    border-radius: 12px;
  }

  &__point-title {
    font-size: 1rem;
    font-weight: 600;
    color: $home3-text;
    margin-bottom: 4px;
  }

  &__point-text {
    font-size: 0.925rem;
    line-height: 1.65;
    color: $home3-text-muted;
    margin: 0;
  }

  &__visual {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  &__hero-img {
    filter: drop-shadow(0 16px 30px rgba(31, 65, 104, 0.2));
  }

  &__badge {
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    padding: 10px 20px;
    font-size: 0.8rem;
    font-weight: 600;
    color: #fff;
    background: $home3-navy;
    border-radius: 100px;
    box-shadow: $home3-shadow-lg;
    white-space: nowrap;
  }
}

@media (max-width: 960px) {
  .home3-about {
    &__hero-img {
      max-width: 420px !important;
    }
  }
}
</style>
